/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { TextField } from "@mui/material";
import { ComponentTestimonialEditWrapper } from "./component-image-link-wrapper";
import LabelledField from "components/labelled-field";
import { TestimonialItemEditor } from "./list-item";

const TestimonialComponentEdit = () => {
    const { component, update, updateFactory } = useUpdateComponent();
    const title = component?.title;
    const subtitle = component?.subtitle;
    const testimonialList = component?.testimonial_list;

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };
    const onChangeSubtitle = (event) => {
        const subtitle = event.target.value;
        update("subtitle", subtitle);
    };

    const onChangeTestimonialList = updateFactory("testimonial_list");
    return (
        <div className="simplicity-editor-frame testimonial-editor-frame">
            <div className="testimonial-editor-title-container">
                <LabelledField label="Title">
                    <TextField
                        id="testimonial_title"
                        fullWidth={true}
                        value={title}
                        placeholder="Add a title"
                        onChange={onChangeTitle}
                    />
                </LabelledField>
                <LabelledField label="Subtitle">
                    <TextField
                        id="testimonial_subtitle"
                        fullWidth={true}
                        value={subtitle}
                        placeholder="Add a subtitle"
                        onChange={onChangeSubtitle}
                    />
                </LabelledField>
            </div>
            <div className="testimonial-editor-links-container">
                <ComponentTestimonialEditWrapper
                    list={testimonialList}
                    onChange={onChangeTestimonialList}
                >
                    <TestimonialItemEditor />
                </ComponentTestimonialEditWrapper>
            </div>
        </div>
    );
};
TestimonialComponentEdit.displayName = "TestimonialComponentEdit";
export { TestimonialComponentEdit };
